import * as modulePermissionsAction from '../../constants/action-types';

export const setModulePermissions = data => ({
  type: modulePermissionsAction.SET_MODULE_PERMISSIONS,
  payload: data,
});